module.exports = __webpack_public_path__ + "f865b2f87aee47d3a97181582ac878eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-construction.png
// module id = 2255
// module chunks = 0